import api from '@pray/shared/utils/api';

export async function getArtistInstagramSummary({ artistId = '' }) {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/socials/instagram`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
